"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import styles from './SkeletonText.module.scss.mjs';

const SkeletonText = (props) => {
  const { width, style = {}, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "div",
    {
      "aria-hidden": true,
      className: styles.skeletonText,
      style: { width, ...style },
      ...rest
    }
  );
};

export { SkeletonText, SkeletonText as default };
//# sourceMappingURL=SkeletonText.mjs.map
